import React, { useState } from "react";

// this component include label, input text box
// required *, help/tip message, and error state with error message

// base on input props.isRequired, props.hasError
// update the className, to show error, and required

// use props.value to set text
// use on change props.getTextString return new value to parent

const TextArea = (props) => {
  const [currentLength, setCurrentLength] = useState(0);


  function defaultOnChange(e) {
    // onChange is return value to formik
    if (props.onChange !== undefined && props.onChange !== null) {

		props.onChange(e);
    } else {

    }

    // getTextString is return value to text update change handler
    if (props.getTextString !== undefined && props.getTextString !== null) {

      props.getTextString(e.target.value);
    } else {

    }

    // update the counter
    setCurrentLength(e.target.value.length);
  }
  function defaultOnBlur(e) {
    // onChange is return value to formik
    if (props.onBlur !== undefined && props.onBlur !== null) {
		
      props.onBlur(e);
    } else {
     
    }

    // getTextString is return value to text update change handler
    if (props.getTextString !== undefined && props.getTextString !== null) {
		
      props.getTextString(e.target.value);
    } else {
     
    }

    // update the counter
    setCurrentLength(e.target.value.length);
  }

  return (
    <div className="inputbox">
      <label
        className={`inputbox__label ${
          props.hasError ? "inputbox__label--error" : ""
        }
        ${props.isDisabled ? "inputbox__label--disabled" : ""}
        `}
      >
        {props.labelText}
        <span
          className="inputbox__required"
          style={props.isRequired ? {} : { display: "none" }}
        >
          *
        </span>
        <textarea
          id={props.id}
          rows={props.rows}
          type="text"
          required={props.isRequired ? true : false}
          placeholder=""
          className={`inputbox__textbox inputbox__textarea ${
            props.hasError ? "inputbox__textbox--error" : ""
          }`}
          value={props.value}
          onChange={(e) => defaultOnChange(e)}
          onBlur={(e) => defaultOnBlur(e)}
          disabled={props.isDisabled ? true : false}
          maxLength={props.maxLength}
        />
        <div
          className="inputbox_counter"
          style={props.maxLength ? {} : { display: "none" }}
        >
          {currentLength}/{props.maxLength}
        </div>
        <span className="inputbox__help">{props.helpMessage}</span>
        <span
          className="inputbox__error"
          style={props.hasError ? {} : { display: "none" }}
        >
          {props.errorMessage}
        </span>
      </label>
    </div>
  );
};

export default TextArea;
